var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3.5,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F9FAFB",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.582 30.9195L20.2064 29.1409C20.5022 29.0271 20.6501 28.9703 20.7885 28.896C20.9114 28.83 21.0285 28.7539 21.1387 28.6684C21.2628 28.5721 21.3748 28.46 21.5989 28.236L30.9987 18.8362C31.9192 17.9157 31.9192 16.4233 30.9987 15.5029C30.0782 14.5824 28.5859 14.5824 27.6654 15.5029L18.2656 24.9026C18.0415 25.1267 17.9295 25.2388 17.8332 25.3628C17.7477 25.473 17.6715 25.5902 17.6056 25.7131C17.5313 25.8515 17.4744 25.9994 17.3606 26.2951L15.582 30.9195ZM15.582 30.9195L17.2971 26.4603C17.4199 26.1412 17.4812 25.9817 17.5865 25.9086C17.6785 25.8447 17.7923 25.8206 17.9023 25.8416C18.0281 25.8656 18.149 25.9865 18.3908 26.2282L20.2733 28.1108C20.5151 28.3526 20.636 28.4734 20.66 28.5993C20.681 28.7093 20.6569 28.8231 20.593 28.9151C20.5199 29.0204 20.3604 29.0817 20.0413 29.2044L15.582 30.9195Z",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.2eeb934849adaad391ec90970648ee38.svg";
export { ForwardRef as ReactComponent };